/** Zoom factor of one Controls zoom-in / zoom-out click (v11). */
export const ZOOM_STEP = 1.2;
